import React from "react";

const Header = () => {
  return (
    <div>
      <h1>Simpsons Memory Game</h1>
      <p>
        Get points by clicking a character but don't click on any more than
        once!
      </p>
    </div>
  );
};

export default Header;
